<template>
  <div
    v-if="canShow"
    class="product-set-price"
  >
    <div
      v-if="discountPercentage"
      class="badge badge-special"
    >
      Sie sparen {{ discountPercentage }}%
    </div>
    <div class="product__base-price">
      <span
        v-if="hasDiscount"
        class="product__base-price__old"
      >
        <span class="unit">{{ currency }}/{{ unit }}</span>
        <span class="price">{{ formattedOldPrice }}</span>
      </span>
      <span
        :class="[ hasDiscount ? 'product__base-price__special' : 'product__base-price__regular' ]"
      >
        <span class="unit">{{ currency }}/{{ unit }}</span>
        <span class="price">{{ formattedPrice }}</span>
      </span>
    </div>

    <div class="product-set-price__set-total">
      <span class="product-set-price__set-label">Preis pro Set</span>
      <SfPrice :regular="setPrice" />
    </div>

    <div
      v-if="setAmountLabel"
      class="product-set-price__set-contents"
    >
      Inhalt pro Set <strong>{{ setAmountLabel }}</strong>
    </div>
  </div>
</template>

<script>
import { SfPrice } from '@storefront-ui/vue'
import { price } from '@vue-storefront/core/filters/price'
import { getProductPrice } from 'theme/helpers'
import { basePriceUnit, discountPercentage as getDiscountPercentage } from 'theme/helpers/custom'
import {
  getSelectedBundleOptionValue,
  getBundleBasePriceTotal,
  getBundleBasePriceTotalOld
} from 'theme/helpers/bundle'

export default {
  name: 'MProductSetPrice',
  components: {
    SfPrice
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    firstOption () {
      return (this.product.bundle_options || []).find(() => true) || null
    },
    firstOptionValue () {
      return this.firstOption ? getSelectedBundleOptionValue(this.product, this.firstOption) : null
    },
    productPrice () {
      return getProductPrice(this.product)
    },
    basePriceTotal () {
      return getBundleBasePriceTotal(this.product)
    },
    basePriceTotalOld () {
      return getBundleBasePriceTotalOld(this.product)
    },
    hasDiscount () {
      return this.basePriceTotalOld > this.basePriceTotal
    },
    discountPercentage () {
      if (!this.hasDiscount) {
        return null
      }
      return getDiscountPercentage(this.basePriceTotal, this.basePriceTotalOld)
    },
    formattedPrice () {
      return price(this.basePriceTotal).split(' ')[0]
    },
    formattedOldPrice () {
      return price(this.basePriceTotalOld).split(' ')[0]
    },
    currency () {
      if (this.firstOptionValue) {
        return price(this.firstOptionValue.price).split(' ')[1]
      }
      return price(this.basePriceTotal).split(' ')[1]
    },
    unit () {
      const selectedProduct = this.firstOptionValue && this.firstOptionValue.product
      if (!selectedProduct) {
        return 'm²'
      }

      const rawUnit = selectedProduct.baseprice_product_unit
      if (!isNaN(parseFloat(rawUnit)) && isFinite(rawUnit)) {
        return basePriceUnit(rawUnit)
      }

      return rawUnit
    },
    setPrice () {
      let total = null
      let qty = 1

      for (const option of (this.product.bundle_options || [])) {
        const selected = getSelectedBundleOptionValue(this.product, option)
        if (!selected) continue

        if (total === null) {
          total = this.productPrice.special || this.productPrice.regular
          qty = selected.qty || 1
          total *= qty
          continue
        }

        if (!selected.product) continue
        const optionPrice = selected.price
        if (!isNaN(optionPrice)) {
          total += optionPrice * selected.qty
        }
      }

      if (total === null || !qty) return null
      return price(total / qty)
    },
    setAmountLabel () {
      const selectedProduct = this.firstOptionValue && this.firstOptionValue.product
      if (!selectedProduct || !selectedProduct.baseprice_product_amount) return ''

      const amount = Number(selectedProduct.baseprice_product_amount).toLocaleString('de-DE', {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3
      })
      return `${amount} ${this.unit}`
    },
    canShow () {
      return typeof this.basePriceTotal === 'number' && !isNaN(this.basePriceTotal)
    }
  }
}
</script>
